<template>
  <div class="extra-bonus-circle" v-if="currentPeriodBonuses">
    <ExtraBonusIntersectionObserver
      :reset="reset"
      :card="card"
      :stateId="stateId"
    >
      <div class="extra-bonus-circle_svg-wrapper">
        <svg
          width="200"
          height="200"
          viewBox="-25 -25 200 200"
          :class="['extra-bonus-circle_svg', currentTooltipShow ? `extra-bonus-circle_svg-tooltip__${currentTooltipShow}` : '']"
        >
          <g>
            <defs>
              <mask id="msk0">
                <path d="M79 8.01259C114.141 10.0817 142 39.235 142 74.8952C142 85.7036 139.441 95.9143 134.895 104.954L141.873 108.887C147.07 98.6828 150 87.1312 150 74.8952C150 34.8157 118.562 2.07897 79 0V8.01259Z" fill="white" fill-opacity="1"/>
              </mask>
              <mask id="msk1">
                <path d="M130.88 111.874C118.883 129.966 98.3345 141.895 75 141.895C51.6655 141.895 31.1172 129.966 19.1204 111.874L12.1339 115.812C25.5167 136.332 48.6744 149.895 75 149.895C101.326 149.895 124.483 136.332 137.866 115.812L130.88 111.874Z" fill="white" fill-opacity="1"/>
              </mask>
              <mask id="msk2">
                <path d="M71 8.01259V0C31.4383 2.07897 0 34.8157 0 74.8952C0 87.1312 2.93019 98.6828 8.12715 108.887L15.105 104.954C10.5593 95.9143 8 85.7036 8 74.8952C8 39.235 35.8591 10.0817 71 8.01259Z" fill="white" fill-opacity="1"/>
              </mask>
              <mask id="msk-1"></mask>
              <mask id="msk4"></mask>
            </defs>
            <g :mask="`url(#msk${progress})`" v-if="progress !== 3">
              <circle
                class="dashed-circle"
                cx="75"
                cy="75"
                r="69"
                :stroke="color"
              >
                <animateTransform
                  attributeName="transform"
                  begin="0s"
                  dur="20s"
                  type="rotate"
                  from="0 75 75"
                  to="360 75 75"
                  repeatCount="indefinite"
                />
              </circle>
            </g>
            <g>
              <path
                id="path0"
                v-if="progress !== 0 || (progress === 0 && reset)"
                d="M79 8.01259C114.141 10.0817 142 39.235 142 74.8952C142 85.7036 139.441 95.9143 134.895 104.954L141.873 108.887C147.07 98.6828 150 87.1312 150 74.8952C150 34.8157 118.562 2.07897 79 0V8.01259Z"
                :fill="colors[0] || '#FFF'"
                :fill-opacity="colors[0] ? 1 : 0.2"
                :filter="`drop-shadow(0px 3px 13px ${colors[0]})`"
              />
              <path
                id="path1"
                v-if="progress !== 1 || (progress === 1 && reset)"
                d="M130.88 111.874C118.883 129.966 98.3345 141.895 75 141.895C51.6655 141.895 31.1172 129.966 19.1204 111.874L12.1339 115.812C25.5167 136.332 48.6744 149.895 75 149.895C101.326 149.895 124.483 136.332 137.866 115.812L130.88 111.874Z"
                :fill="colors[1] || '#FFF'"
                :fill-opacity="colors[1] ? 1 : 0.2"
                :filter="`drop-shadow(0px 3px 13px ${colors[1]})`"
              />
              <path
                id="path2"
                v-if="progress !== 2 || (progress === 2 && reset)"
                d="M71 8.01259V0C31.4383 2.07897 0 34.8157 0 74.8952C0 87.1312 2.93019 98.6828 8.12715 108.887L15.105 104.954C10.5593 95.9143 8 85.7036 8 74.8952C8 39.235 35.8591 10.0817 71 8.01259Z"
                :fill="colors[2] || '#FFF'"
                :fill-opacity="colors[2] ? 1 : 0.2"
                :filter="`drop-shadow(0px 3px 13px ${colors[2]})`"
              />
            </g>
          </g>
          <image :href="image" alt="" x="0" y="-10" />
        </svg>
        <div
          class="extra-bonus-circle_hover-place"
        >
          <ExtraBonusTooltip
            :title="tooltipHeader"
            :content="tooltipDescription"
          />
        </div>
      </div>
    </ExtraBonusIntersectionObserver>
    <div class="extra-bonus-circle_description">
      <h3 class="extra-bonus-circle_heading">{{ header }}</h3>
      <div class="extra-bonus-circle_description-body" v-html="description" />
      <a
        href="#"
        class="extra-bonus-circle_link link"
        @click.prevent="showMoreDialog = true"
      >{{ $c('Узнать больше о программе') }}</a>
      <Portal to="overlay" v-if="showMoreDialog">
        <PopUp
          :pop-up-component="ExtraBonusMore"
          :pop-up-props="{game, partner}"
          pop-up-valign="top"
          @closePopUp="showMoreDialog = false"
        />
      </Portal>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import ExtraBonusTooltip from './ExtrabonusTooltip'
import PopUp from '@/components/PopUp/PopUp'
import ExtraBonusMore from '@/components/ExtraBonus/ExtraBonusMore'
import { GAME_TO_COLORS, ATTENTION_COLOR } from '@/constants'
import ExtraBonusIntersectionObserver from '@/components/ExtraBonus/ExtraBonusIntersectionObserver'

@Component({
  components: {
    ExtraBonusTooltip,
    PopUp,
    ExtraBonusMore,
    ExtraBonusIntersectionObserver
  }
})
class ExtraBonusCircle extends Vue {
  @Prop({
    required: true,
    type: String
  }) game

  @Prop({
    required: true,
    type: Object
  }) card

  @Prop({
    required: true,
    type: String
  }) partner

  @Prop({
    required: true,
    type: Object
  }) extraBonus

  currentTooltipShow = null
  showMoreDialog = false

  ExtraBonusMore = ExtraBonusMore

  get color () {
    return GAME_TO_COLORS[this.game]
  }

  get progress () {
    return this.extraBonus.progress
  }

  get period () {
    return this.extraBonus.period
  }

  get reset () {
    return this.extraBonus.reset
  }

  get stateId () {
    return this.extraBonus.stateId
  }

  get currentPeriodBonuses () {
    if (this.period === undefined) return {}
    return this.extraBonus.periods.find(item => item.period === this.period)
  }

  get image () {
    return this.currentPeriodBonuses.image
  }

  get header () {
    return this.currentPeriodBonuses.mainHeader
  }

  get description () {
    return this.currentPeriodBonuses.mainDescription
  }

  get tooltipHeader () {
    return this.currentPeriodBonuses.tooltipHeader
  }

  get tooltipDescription () {
    return this.currentPeriodBonuses.tooltipDescription
  }

  get colors () {
    const result = []
    for (let i = 0; i <= this.progress; i++) {
      if (this.reset) {
        result.push(ATTENTION_COLOR)
      } else {
        result.push(GAME_TO_COLORS[this.game])
      }
    }
    return result
  }

  onShowTooltip (index) {
    this.currentTooltipShow = index + 1
  }

  onHideTooltip () {
    this.currentTooltipShow = null
  }
}
export default ExtraBonusCircle
</script>

<style lang="scss">
.extra-bonus-circle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &_description {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  &_heading {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 8px;
  }
  &_description-body {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: #999999;
    margin-bottom: 8px;
  }
  &_link {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #CCCCCC;
  }
  &_svg-wrapper {
    position: relative;
    display: inline-block;
  }
  &_hover-place {
    width: calc(100% - 50px);
    height: calc(100% - 50px);
    position: absolute;
    left: 25px;
    top: 25px;
    > .extrabonus-tooltip {
      position: absolute;
      opacity: 0;
      pointer-events: none;
      transition: opacity .3s ease;
      top: 0;
      left: 50%;
      @include media_desktop {
        left: auto;
        top: 50%;
      }
    }
    &:hover {
      > .extrabonus-tooltip {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
}

.extra-bonus-circle_svg {
  path {
    transition: fill-opacity .3s ease;
  }
}

.extra-bonus-circle_svg-tooltip__0 {
  #path0 {
    fill-opacity: .3;
  }
  #msk0 path {
    fill-opacity: .3;
  }
}
.extra-bonus-circle_svg-tooltip__1 {
  #path1 {
    fill-opacity: .3;
  }
  #msk1 path {
    fill-opacity: .3;
  }
}
.extra-bonus-circle_svg-tooltip__2 {
  #path2 {
    fill-opacity: .3;
  }
  #msk2 path {
    fill-opacity: .3;
  }
}
.dashed-circle {
  fill: none;
  stroke-dasharray: 2, 4;
  stroke-width: 12;
}
</style>
